<script>
import Monitor from '@/services/Monitor';
import validationMessages from '@/components/validations';
import { required, maxLength } from "vuelidate/lib/validators";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";


export default {
  props: {
    dashboardAnnouncementData: {
      type: Object,
      required: true,
      default: () => ({
        dashboard_version: '',
        tenant: 'ALL',
        text: '',
        button_text: '',
        text_color: null,
        button_link: null,
        background_color: null,
        button_color: '#34c38f',
        button_text_color: '#000000',
        img_url: null,
        video_url: null
      })
    }
  },
  components:{
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      currentDomainPrefix: '',
      dashboardUrls: [],
      showLoader: false,
      showModal: false,
      tryingToSubmit: false,
      submitted: false,
      dashboard_version : '',
      text : '',
      button_text : '',
      text_color : null,
      button_link : null,
      background_color : null,
      button_color : '#34c38f',
      button_text_color : '#000000',
      img: '',
      file: '',
      file_additional: [],
      dropzoneOptions_primary: {
        url: '/',
        autoProcessQueue: false,
        addRemoveLinks: true,
        thumbnailWidth: 200,
        acceptedFiles: 'image/png,image/jpeg,video/mp4,video/*',
        thumbnailMethod: 'contain',
        maxFilesize: 50,
        maxFiles: 1,
      },
      tenants_options:[{ "text": "ALL", "value": "ALL" }],
      media_options:['Image', 'Video','Text'],
      media: 'Image',
      tenant: 'ALL',
      csrf_token: localStorage.getItem('csrf_token'),
      existing_img_url: null,
      existing_video_url: null,
      removeImage: false,
      removeVideo: false,
    };
  },
  watch: {
    dashboardAnnouncementData: {
      immediate: true,
      handler(newValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          this.populateFormData(newValue);
        }
      }
    },
    showModal(newValue) {
      if (!newValue) {
        if (this.dashboardAnnouncementData && Object.keys(this.dashboardAnnouncementData).length > 0) {
          this.populateFormData(this.dashboardAnnouncementData);
        }
      }
    },

     button_link(newVal) {
      if (!newVal || !newVal.length) {
        this.currentDomainPrefix = '';
        return;
      }

      const input = newVal.trim();

      // Match even if protocol or formatting differs
      const matchedDomain = this.dashboardUrls.find(domain =>
        input.includes(domain)
      );

      if (matchedDomain) {
        let path = input.replace(matchedDomain, '');

        // Add slash if missing
        if (!path.startsWith('/')) {
          path = '/' + path;
        }

        // 🔒 Prevent infinite loop
        if (this.button_link !== path) {
          this.button_link = path;
        }

        this.currentDomainPrefix = matchedDomain;
      }
    }

  },
  methods: {
    populateFormData(data) {
      this.dashboard_version = data.dashboard_version || '';
      this.tenant = data.tenant || 'ALL';
      this.text = data.text || '';
      this.button_text = data.button_text || '';
      this.background_color = data.background_color || null;
      this.text_color = data.text_color || null;
      this.button_color = data.button_color || '#34c38f';
      this.button_text_color = data.button_text_color || '#000000';
      this.button_link = data.button_link || null;
      this.existing_img_url = data.img_url || null;
      this.existing_video_url = data.video_url || null;
      this.removeImage = false;
      this.removeVideo = false;
      
      // Determine media type based on existing URLs
      if (this.existing_video_url) {
        this.media = 'Video';
      } else if (this.existing_img_url) {
        this.media = 'Image';
      } else {
        this.media = 'Text';
      }
    },
    refreshData() {
      this.$emit('onRefresh');
    },

    async updateDashboardMessage() {
      this.tryingToSubmit = true;
      this.submitted = true;
      this.showLoader = true;

      try {
        this.showLoader = true;

        let formData = new FormData()
        formData.append('dashboard_version', this.dashboard_version)
        formData.append('tenant', this.tenant)
        formData.append('text', this.text)
        formData.append('button_text', this.button_text)
        formData.append('background_color', this.background_color)
        formData.append('button_color', this.button_color)
        formData.append('text_color', this.text_color)
        formData.append('button_text_color', this.button_text_color)
        formData.append('button_link', this.button_link)
        formData.append('_method', 'PATCH')
        formData.append('csrf_token', this.csrf_token)

        if(this.file){
          formData.append('file', this.file)
        }

        // Add flags to remove image/video if user clicked remove
        if (this.removeImage) {
          formData.append('remove_image', '1')
        }
        if (this.removeVideo) {
          formData.append('remove_video', '1')
        }

        const response = await Monitor.updateDashboardMessages(this.dashboard_version, formData);

        this.successmsg('Dashboard Message Updated!');

        this.refreshData();

        this.closeModal();
      } catch (error) {
        console.error('Error occurred:', error);
        this.error = error.response?.data?.error || "An error occurred";
        this.failedmsg(this.error);
        this.showLoader = false;

      } finally {
        this.tryingToSubmit = false;
      }
    },

    async getTenants() {
      try {
        this.showLoader = true;
        const response = await Monitor.getTenants();
        var all_tenants = response.data.tenants.map(tenant => ({
          text: tenant,
          value: tenant,
        }));
        Array.prototype.push.apply(this.tenants_options , all_tenants);

      } catch (error) {
        console.log('Error fetching tenants:', error);
      } finally {
        this.showLoader = false;
      }
    },

    selectFile(files){
      setTimeout(() => {
        let queuedFiles = this.$refs.myVueDropzone_primary.getQueuedFiles();

        if (queuedFiles.length > 1) {
          this.failedmsg('You can only have one primary image')

          files.forEach((value) => {
            this.$refs.myVueDropzone_primary.removeFile(value)
          });
        }

        this.file = queuedFiles[0];
        // If a new file is selected, clear the remove flags
        if (this.file) {
          this.removeImage = false;
          this.removeVideo = false;
        }

      }, 250);
    },

    removeCurrentImage() {
      this.removeImage = true;
      this.existing_img_url = null;
      this.file = '';
      if (this.$refs.myVueDropzone_primary) {
        this.$refs.myVueDropzone_primary.removeAllFiles(true);
      }
    },

    removeCurrentVideo() {
      this.removeVideo = true;
      this.existing_video_url = null;
      this.file = '';
      if (this.$refs.myVueDropzone_primary) {
        this.$refs.myVueDropzone_primary.removeAllFiles(true);
      }
    },

    async getTenantDashboards() {
      try {
        const resDashboards = await Monitor.getTenantDashboards();
        this.dashboardUrls = resDashboards.data.map(d => d.dashboard_url);
      } catch (error) {
        this.error = error.response?.data?.error || "";
      }
    },

    closeModal() {
      this.showModal = false;
      this.showLoader = false;
      this.file = '';
      this.removeImage = false;
      this.removeVideo = false;
      this.currentDomainPrefix = ''
      if (this.$refs.myVueDropzone_primary) {
        this.$refs.myVueDropzone_primary.removeAllFiles(true);
      }
    },

    async modalShown() {
        this.showModal = true;
        this.getTenants()
        if (this.dashboardAnnouncementData && Object.keys(this.dashboardAnnouncementData).length > 0) {
          this.populateFormData(this.dashboardAnnouncementData);
        }
        this.getTenantDashboards()
    },

  },

};
</script>

<template>
  <b-modal @shown="modalShown" id="edit_dashboard_announcements" v-model="showModal" @hidden="closeModal" title="Edit Dashboard Announcements" title-class="font-18" size="lg">
    <form @submit.prevent="updateDashboardMessage" v-if="!showLoader">
      <div class="row">
        <div class="col-4">
          <b-form-group label="Dashboard Version" label-for="formrow-title-input" class="mb-3">
            <b-form-input
                v-model.trim="dashboard_version"
                type="text"
                id="dashboard_version"
                aria-describedby="title-feedback"
                disabled
            >
            </b-form-input>
            <small class="text-muted">Dashboard version cannot be changed</small>
          </b-form-group>
        </div>
         <div class="col-4">
            <b-form-group label="Select Team" label-for="formrow-tenant-input" class="mb-3">
                <b-form-select
                        v-model="tenant"
                        :options="tenants_options"
                ></b-form-select>
            </b-form-group>
         </div>
        <div class="col-4">
          <b-form-group label="Select Type" label-for="formrow-tenant-input" class="mb-3">
            <b-form-select
                    v-model="media"
                    :options="media_options"
            ></b-form-select>
          </b-form-group>
        </div>
        <div v-if="media === 'Video'">
          <b-card-text class="text-center">
            <div class="row mb-3">
              <div class="col-12">
                <h5 class="text-center">Video Upload</h5>
                <div v-if="existing_video_url && !removeVideo" class="mb-3">
                  <p class="text-muted">Current video:</p>
                  <video
                    :src="existing_video_url"
                    class="rounded mx-auto d-block"
                    style="width: 200px; height: auto; border: 2px solid #000; border-radius: 4px;"
                    controls
                  >
                    Your browser does not support the video tag.
                  </video>
                  <div class="mt-2">
                    <b-button variant="danger" size="sm" @click="removeCurrentVideo">
                      <i class="mdi mdi-delete me-1"></i>Remove Video
                    </b-button>
                  </div>
                  <small class="text-muted d-block mt-2">Upload a new file to replace</small>
                </div>
                <vue-dropzone
                        id="dropzone_video"
                        ref="myVueDropzone_primary"
                        :use-custom-slot="true"
                        :options="dropzoneOptions_primary"
                        @vdropzone-files-added="selectFile"
                        no-progress-bar
                >
                  <div class="dropzone-custom-content">
                    <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                    <h4>Drop video file here or click to upload.</h4>
                  </div>
                </vue-dropzone>
              </div>
            </div>
          </b-card-text>
        </div>

        <div v-if="media === 'Image'  || media === 'Text' ">
          <b-form-group label="Content Text" label-for="formrow-text-input" class="mb-3">
            <b-form-input
                v-model.trim="text"
                type="text"
                id="text"
                aria-describedby="title-feedback"
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="Button Text" label-for="formrow-button_text-input" class="mb-3">
            <b-form-input
                v-model.trim="button_text"
                type="text"
                id="button_text"
                aria-describedby="title-feedback"
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="Button Link" label-for="formrow-button_link-input" class="mb-3">
            <b-input-group>
              <b-input-group-prepend is-text class="text-muted" v-if="this.currentDomainPrefix">
                {{ currentDomainPrefix }}
              </b-input-group-prepend>

              <b-form-input v-model.trim="button_link" type="text" id="button_link"></b-form-input>
            </b-input-group>
          </b-form-group>
        <b-card-text class="text-center">
          <div class="row mb-3">
          <div class="col-12">
            <h5 class="text-center">Image</h5>
            <div v-if="existing_img_url && !removeImage" class="mb-3">
              <p class="text-muted">Current image:</p>
              <img
                :src="existing_img_url"
                class="img-thumbnail rounded mx-auto d-block"
                style="width: 200px; height: auto;"
                alt="Current Image"
              />
              <div class="mt-2">
                <b-button variant="danger" size="sm" @click="removeCurrentImage">
                  <i class="mdi mdi-delete me-1"></i>Remove Image
                </b-button>
              </div>
              <small class="text-muted d-block mt-2">Upload a new file to replace</small>
            </div>
            <vue-dropzone
                id="dropzone_primary"
                ref="myVueDropzone_primary"
                :use-custom-slot="true"
                :options="dropzoneOptions_primary"
                @vdropzone-files-added="selectFile"
                no-progress-bar
            >
              <div class="dropzone-custom-content">
                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                <h4>Drop file here or click to upload.</h4>
              </div>
            </vue-dropzone>
          </div>
        </div>
        </b-card-text>
        <b-card
            class="mb-3"
        >
          <b-row>
            <!-- Background Color Picker (col-6) -->
            <b-col cols="12" sm="6">
              <!-- Background Color Picker Form Group -->
              <b-form-group
                  id="example-background-color"
                  label-for="formrow-background-color-input"
                  label="Select Button Color"
                  class="mb-3"
              >
                <b-form-input
                    id="background-color"
                    type="color"
                    name="button_color"
                    v-model="button_color"
                    class="form-control form-control-color"
                ></b-form-input>
              </b-form-group>

              <!-- Background Hex Code Input -->
              <b-form-group
                  label="Button Hex Code"
                  label-for="button-color-hex-code"
                  class="mb-3"
              >
                <b-form-input
                    id="button-color-hex-code"
                    type="text"
                    v-model="button_color"
                    class="form-control"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- Button Color Picker (col-6) -->
            <b-col cols="12" sm="6">
              <!-- Button Color Picker Form Group -->
              <b-form-group
                  id="example-button_text_color"
                  label-for="formrow-button_text_color-input"
                  label="Select Button Text Color"
                  class="mb-3"
              >
                <b-form-input
                    id="button_text_color"
                    type="color"
                    name="button_text_color"
                    v-model="button_text_color"
                    class="form-control form-control-color"
                ></b-form-input>
              </b-form-group>

              <!-- Button Hex Code Input -->
              <b-form-group
                  label="Button Text Hex Code"
                  label-for="button-text-color-hex-code"
                  class="mb-3"
              >
                <b-form-input
                    id="button-text-color-hex-code"
                    type="text"
                    v-model="button_text_color"
                    class="form-control"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <!-- Background Color Picker (col-6) -->
            <b-col cols="12" sm="6">
              <!-- Background Color Picker Form Group -->
              <b-form-group
                  id="example-background-color"
                  label-for="formrow-background-color-input"
                  label="Select Background Color"
                  class="mb-3"
              >
                <b-form-input
                    id="background-color"
                    type="color"
                    name="background_color"
                    v-model="background_color"
                    class="form-control form-control-color"
                ></b-form-input>
              </b-form-group>

              <!-- Background Hex Code Input -->
              <b-form-group
                  label="Background Hex Code"
                  label-for="background-hex-code"
                  class="mb-3"
              >
                <b-form-input
                    id="background-hex-code"
                    type="text"
                    v-model="background_color"
                    class="form-control"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- Button Color Picker (col-6) -->
            <b-col cols="12" sm="6">
              <!-- Button Color Picker Form Group -->
              <b-form-group
                  id="example-text_color"
                  label-for="formrow-text_color-input"
                  label="Select Text Color"
                  class="mb-3"
              >
                <b-form-input
                    id="text_color"
                    type="color"
                    name="text_color"
                    v-model="text_color"
                    class="form-control form-control-color"
                ></b-form-input>
              </b-form-group>

              <!-- Button Hex Code Input -->
              <b-form-group
                  label="Text Hex Code"
                  label-for="button-hex-code"
                  class="mb-3"
              >
                <b-form-input
                    id="button-hex-code"
                    type="text"
                    v-model="text_color"
                    class="form-control"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

        </b-card>
        </div>
      </div>
    </form>
    <div v-else>
      <div class="card-body d-flex align-items-center justify-content-center" v-if="showLoader">
        <div class="row">
          <div class="col-12">
            <div class="row  align-items-center justify-content-center">
              <b-spinner large></b-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="updateDashboardMessage" :disabled="tryingToSubmit || showLoader">
        <b-spinner v-show="tryingToSubmit" small></b-spinner>
        Update
      </b-button>
    </template>
  </b-modal>
</template>

